import React from 'react';

import { Text, View } from '@react-pdf/renderer';

/**
 * Renders EmptyUserData export lines in PDF reports.
 * @param {Object} props
 * @param {string[]} [props.lines=[]]
 * @param {Object} props.styles - PDF styles from getTablePDFStyle
 */
const EmptyUserDataPDF = ({ lines = [], styles }) => (
  <View style={{ marginTop: 16 }}>
    {lines.map((line, index) => (
      <Text key={index} style={{ ...styles.title, fontWeight: 'normal', marginBottom: 8 }}>
        {line}
      </Text>
    ))}
  </View>
);

export default EmptyUserDataPDF;
